import moment from 'moment';
import { config } from '../../config/env';
import { ProjectsStore } from '../../types/redux/stores/projects.types';

/**
 * This function calculates whether or not we should (re)fetch projects data.
 * If the Client dimension is not displayed we should fetch projects for all clients (`clientId = ""`);
 * Otherwise, we verify that the `clientId` exists and that the last fetch of projects was more than
 * `VITE_APP_DIMENSION_SYNC_TIMEOUT` minutes ago.
 * @param projectsStore Redux state for projects
 * @param clientId The client for which we should fetch the projects
 * @param showCustomer Whether or not the client dimension is displayed
 * @returns boolean
 */
export function shouldFetchProjectsOfClient(
  projectsStore: ProjectsStore,
  clientId: string | null | undefined,
  showCustomer: boolean | null | undefined,
): boolean {
  if (!showCustomer && !projectsStore?.perClientId.all?.lastSync) return true;

  if (showCustomer && !clientId) return false;

  const lastSync = projectsStore?.perClientId[clientId || 'all']?.lastSync;
  if (!lastSync) return true;

  // We check if lastSync can be converted into a valid moment object
  const dateOfLastSync = moment(lastSync);
  if (!dateOfLastSync.isValid()) return true;

  const dateNow = moment();
  return dateNow.diff(dateOfLastSync, 'minutes') > config.VITE_APP_DIMENSION_SYNC_TIMEOUT;
}
